"use client";

import { c as _c } from "react/compiler-runtime";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import { useIsVersionStale } from "@/hooks/useIsVersionStale";
import { faRefresh } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { type JSX } from "react";
const NewVersionToast = () => {
  const $ = _c(4);
  const isVersionStale = useIsVersionStale();
  const {
    isApp
  } = useDeviceInfo();
  if (!isVersionStale) {
    return null;
  }
  const t0 = `tw-fixed ${isApp ? "tw-bottom-24" : "tw-bottom-6"} tw-left-6 sm:tw-left-auto tw-right-6 tw-z-[1000] tw-pointer-events-none tailwind-scope`;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="tw-text-sm tw-leading-none tw-font-semibold">A new version is available</span>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className={"toast-shell tw-relative tw-pointer-events-auto tw-flex tw-items-center tw-justify-between sm:tw-justify-start tw-gap-3\n                 tw-rounded-xl tw-bg-iron-700/80 tw-border tw-border-iron-700 tw-border-solid\n                 tw-backdrop-blur-md tw-px-4 tw-py-2.5 tw-text-iron-50\n                 tw-shadow-[0_12px_28px_-6px_rgba(0,0,0,0.75)]\n                 tw-animate-toast-in\n                 before:tw-content-[''] before:tw-absolute before:tw-inset-0 before:tw-rounded-[inherit]\n                 before:tw-bg-[radial-gradient(140%_140%_at_100%_0,_rgba(255,255,255,0.06)_0%,_transparent_70%)]\n                 before:tw-pointer-events-none"}>{t1}<button onClick={_temp} aria-label="Refresh page" title="Refresh page" className={"tw-flex tw-items-center tw-justify-center tw-gap-x-2\n                   tw-rounded-md tw-bg-primary-500 tw-border-none tw-p-2\n                   desktop-hover:hover:tw-bg-primary-500/80 active:tw-scale-95\n                   focus-visible:tw-outline-none\n                   focus-visible:tw-ring-2 focus-visible:tw-ring-inset\n                   focus-visible:tw-ring-primary-500 tw-transition-all tw-duration-300 tw-ease-out"}><FontAwesomeIcon icon={faRefresh} className="tw-h-4 tw-w-4 tw-flex-shrink-0" /></button></div>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t0) {
    t3 = <div className={t0}>{t2}</div>;
    $[2] = t0;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
export default NewVersionToast;
function _temp() {
  return globalThis.location.reload();
}